module.exports = __webpack_public_path__ + "img/high-discharging-start.36af284f.png";